import { render, staticRenderFns } from "./First.vue?vue&type=template&id=201cc4b8&scoped=true&"
import script from "./First.vue?vue&type=script&lang=js&"
export * from "./First.vue?vue&type=script&lang=js&"
import style0 from "./First.vue?vue&type=style&index=0&id=201cc4b8&scoped=true&lang=css&"
import style1 from "./First.vue?vue&type=style&index=1&id=201cc4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201cc4b8",
  null
  
)

export default component.exports